import React from 'react'
import { Timeline, TimelineItem } from 'vertical-timeline-component-for-react'

const Experience = (props) => {
  return (
    <div style={props.styles.experience}>
      <h2 style={props.styles.header}>Experience</h2>
      <hr />

      <Timeline lineColor={'#ddd'}>
        <TimelineItem
          key='001'
          dateText='01/2020 – Present'
          dateInnerStyle={{ background: 'rgb(218, 173, 134)', color: '#000' }}
          style={{ color: '#e86971' }}>
          <h3>Nando's Chickenland Ltd</h3>
          <h4>Software Engineer</h4>
          <p>
          At Nando's I'm a Software Engineer for the Nandoca platform. In my platform team, I'm a consultant for Dot Net applications as this is my specialisim. My tasks include doing development on our codebases written in Dot Net and helping with deployments and our pipelines in Azure.
          </p>
          <p>
          Currently at Nando's i've been helping the team with development based around legacy applications and architecture that we've inherited from 3rd party software agencies.
          </p>
          <p>
            <ul>
              <li>Working in squads within the Nandoca platform.</li>
              <li>Back-end development using C#, .NET Framework and .NET Core.</li>
              <li>Source control using GIT and  Github.</li>
              <li>Building and maintaining HR systems</li>
              <li>Creating and maintaing pipelines in Azure</li>
              <li>Providing expertise in Microsoft stack</li>
            </ul>
          </p>
        </TimelineItem>
        <TimelineItem
          key='002'
          dateText='01/2019 – 01/2010'
          dateInnerStyle={{ background: '#61b8ff', color: '#000' }}
          bodyContainerStyle={{
            background: '#ddd',
            padding: '20px',
            borderRadius: '8px',
            boxShadow: '0.5rem 0.5rem 2rem 0 rgba(0, 0, 0, 0.2)'
          }}
        >
          <h3 style={{ color: '#61b8ff' }}>Mindshare Worldwide</h3>
          <h4 style={{ color: '#61b8ff' }}>Software Engineer</h4>
          <p>
          In this role I was part of a team of back-end and front-end engineers working on internal systems used in the advertising space. As an engineer at Mindshare, I worked on .Net Web APIs that were called by our applications. We used Dapper for data access to Microsoft SQL Server databases.
          </p>
          <p>
          During my time there, I worked on an application for Unilever called BeSmart. This application used Math formaluae to calculate how much money you should invest in advertising and how much turnover you're estimated to earn.
          </p>
          <p>
          I also particapted in code review and peer reviewing code as our quality control process.
          </p>
          <p>
            <ul>
              <li>Working in a small team of software engineers following agile SDLC.</li>
              <li>Back-end development using C#, .NET Framework, SQL Server, Dapper, Web APIs.</li>
              <li>Front-end development using ReactJS, Webpack, linting, NPM, ES6.</li>
              <li>We use Visual Studio and Visual Studio Code as our IDEs.</li>
              <li>Source control using GIT and VSTS.</li>
              <li>Building internal applications for Mindshare and it's clients.</li>
            </ul>
          </p>
        </TimelineItem>
        <TimelineItem
          key='001'
          dateText='01/2017 – 12/2018'
          dateInnerStyle={{ background: 'rgb(218, 173, 134)', color: '#000' }}
          style={{ color: '#e86971' }}>
          <h3>Instiution of Civil Engineers</h3>
          <h4>.Net Developer</h4>
          <p>
            <ul>
              <li>Built service based architecture using Web APIs to perform business functions.</li>
              <li>Wrote class library and API so we can have APIs but use legacy SOAP web methods.</li>
              <li>Wrote MVC 4 website for training administration tool IPD TSA.</li>
              <li>Wrote Angular 5/Dot Net Core website for fellowship application website FAPPSO.</li>
              <li>Implemented DAPPER class library to improve data layer performance.</li>
              <li>Wrote authentication service using JWT and OWIN with claims.</li>
              <li>Participating in Agile/scrum</li>
              <li>Promoting good software development practises amongst the team.</li>
              <li>Mentoring junior developer with pair programming.</li>
            </ul>
          </p>
        </TimelineItem>
        <TimelineItem
          key='002'
          dateText='03/2016 – 12/2016'
          dateInnerStyle={{ background: '#61b8ff', color: '#000' }}
          bodyContainerStyle={{
            background: '#ddd',
            padding: '20px',
            borderRadius: '8px',
            boxShadow: '0.5rem 0.5rem 2rem 0 rgba(0, 0, 0, 0.2)'
          }}
        >
          <h3 style={{ color: '#61b8ff' }}>AS&K Communications</h3>
          <h4 style={{ color: '#61b8ff' }}>Developer</h4>
          <p>
            <ul>
              <li>Xamarin development for Thrombo Coach with Xamarin.iOS.</li>
              <li>Back-end development with Web API, C#, .net, Entity framework code first and SQL Server.</li>
              <li>Umbraco development for various CMSs that communicate with back-end systems using AJAX, jQuery, JSON and Umbraco back office.</li>
              <li>Sprint planning and scrum in agile environment.</li>
              <li>Unit tests and integration tests using BDD framework specsfor. </li>
              <li>Asp.net Mvc development for XLR learning platform and bespoke CMS for event app.</li>
              <li>In general, these are the technologies that I use, C# 5/6, .net 4.5, Entity Framework code first, ASP.NET MVC 4, .Net framework 4.5 Xamarin.iOS, SQL, Resharper, Ncrunch, Umbraco.</li>
            </ul>
          </p>
        </TimelineItem>
        <TimelineItem
        key='001'
        dateText='09/2014 – 04/2016'
        dateInnerStyle={{ background: 'rgb(218, 173, 134)', color: '#000' }}
        style={{ color: '#e86971' }}>
        <h3>Royal Horticultural Society</h3>
        <h4>Developer</h4>
        <p>
          <ul>
            <li>Back-end development with wcf, Entity framework database first, unit testing.</li>
            <li>Writing AngularJS code with html/css for CRM.</li>
            <li>Web api development for CRM.</li>
            <li>Burning down tasks for the product owner so she knows our progress in the sprint.</li>
            <li>Participating in retrospectives, sprint planning and daily scrum.</li>
            <li>Doing tactical development to help with system migration.</li>
          </ul>
        </p>
      </TimelineItem>
      </Timeline>
    </div>
  )
}

export default Experience
